import PropTypes from 'prop-types'
import React from 'react'
import Form from 'react-bootstrap/Form'

export const Checkbox = React.forwardRef((props, ref) => {
  const {
    label,
    checked,
    onChange,
    name,
    value,
    className,
    disabled,
    type = 'radio',
    errores,
    inline,
    ...rest
  } = props

  const chequeado = value && typeof value === 'object' ? value[name] : checked
  const error = errores && errores[name]

  if (label) {
    return (
      <>
        <Form.Check
          inline={inline}
          ref={ref}
          {...rest}
          checked={chequeado}
          disabled={disabled}
          type={type}
          name={name}
          className={className}
          onChange={() => onChange()}
          label={label}
        />
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
      </>
    )
  }
  const obtenerClasesInput = () =>
    disabled ? 'disabled' : error ? `${className} error` : className

  return (
    <>
      <input
        {...rest}
        type="checkbox"
        ref={ref}
        name={name}
        id={name}
        value={typeof value !== 'object' ? value : undefined}
        checked={chequeado}
        onChange={onChange}
        className={obtenerClasesInput()}
        disabled={disabled}
        aria-disabled={disabled}
      />
      {error && (
        <div className="alert alert-danger mt-1" role="alert">
          {error}
        </div>
      )}
    </>
  )
})

Checkbox.displayName = 'Checkbox'
Checkbox.propTypes = {
  label: PropTypes.node.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.object,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  errores: PropTypes.object,
  inline: PropTypes.bool
}
